export enum SettingsAiDataEventObjectsEnum {
  TOPICS_COPILOT_VIDEO = 'topics_copilot_video',
  SMART_QA_VIDEO = 'smart_qa_video',
  SMART_CSAT_VIDEO = 'smart_csat_video',
  ENABLE_AI_COPILOT_EDUCATION_TIP = 'enable_ai_copilot_education_tip',
  SMART_QA_INFOBOX_CREATE_RULE_LINK = 'smart_qa_infobox_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_CREATE_RULE_LINK = 'smart_qa_activation_banner_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_ANALYTICS_LINK = 'smart_qa_activation_banner_analytics_link',
  CONFIGURE_AI_COPILOT_STEPS_SELECT_INBOXES_TIP = 'configure_ai_copilot_steps_select_inboxes_tip',
  CONFIGURE_AI_COPILOT_STEPS_ADD_SOURCES_TIP = 'configure_ai_copilot_steps_add_sources_tip',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_TIP = 'configure_ai_copilot_knowledge_base_tip',
  FEATURE_HELP_REQUEST_LINK = 'feature_help_request_link',

  AI_REPLIES_PAGE = 'ai_replies_page',
  AI_REPLIES_PAGE_SIDE_PANEL = 'ai_replies_page_side_panel',
}
